(function () {
  'use strict';

  function initSection(section) {
    let activeIcon = null;
    let activePopover = null;
    let originalPopoverParent = null;
    let originalOverlayParent = null;
    const overlay = section.querySelector('.hero-features__overlay');

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function closePopover() {
      if (activeIcon) {
        const item = activeIcon.closest('.hero-features__feature-item');
        activeIcon.classList.remove('active');
        if (item) {
          item.classList.remove('active');
        }
        activeIcon = null;
      }
      if (activePopover) {
        activePopover.classList.remove('show');

        if (isMobile() && originalPopoverParent) {
          originalPopoverParent.appendChild(activePopover);
          originalPopoverParent = null;
        }

        activePopover = null;
      }
      if (overlay) {
        overlay.classList.remove('show');

        if (isMobile() && originalOverlayParent) {
          originalOverlayParent.appendChild(overlay);
          originalOverlayParent = null;
        }
      }
      if (isMobile()) {
        document.body.classList.remove('popover-open');
      }
    }

    function showPopover(icon, popover) {
      closePopover();

      const item = icon.closest('.hero-features__feature-item');
      activeIcon = icon;
      activePopover = popover;
      icon.classList.add('active');
      if (item) {
        item.classList.add('active');
      }

      if (isMobile()) {
        originalPopoverParent = popover.parentNode;
        document.body.appendChild(popover);

        if (overlay) {
          originalOverlayParent = overlay.parentNode;
          document.body.appendChild(overlay);
        }
      }

      if (isMobile() && overlay) {
        requestAnimationFrame(function () {
          overlay.classList.add('show');
        });
        document.body.classList.add('popover-open');
      }

      requestAnimationFrame(function () {
        popover.classList.add('show');
      });
    }

    const items = section.querySelectorAll('.hero-features__feature-item');

    items.forEach(function (item) {
      const icon = item.querySelector('.hero-features__feature-icon');
      const popover = item.querySelector('.hero-features__popover');
      const closeBtn = popover ? popover.querySelector('.hero-features__popover-close') : null;

      if (!icon || !popover) return;

      icon.addEventListener('click', function (e) {
        e.stopPropagation();

        if (icon === activeIcon) {
          closePopover();
          return;
        }

        showPopover(icon, popover);
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closePopover();
        });
      }
    });

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (isMobile() && e.target === overlay) {
          closePopover();
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (isMobile()) return;

      const clickedItem = e.target.closest('.hero-features__feature-item');
      if (!clickedItem && activeIcon) {
        closePopover();
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-hero-features-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
